import { createSlice } from "@reduxjs/toolkit";
/* Set up initial state */
const initialGlobalFeedbackState = {
  show: false,
  message: null,
  type: null,
  onClose: null, // Store the onClose callback
};
/* Set up slice */
const globalFeedbackSlice = createSlice({
  name: "error",
  initialState: initialGlobalFeedbackState,
  reducers: {
    showFeedback(state, action) {
      state.show = true;
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.onClose = action.payload.onClose || null; // Store onClose callback if provided
    },
    hideFeedback(state) {
      state.show = false;
      state.message = null;
      state.type = null;
      state.onClose = null; // Clear onClose when feedback is hidden
    },
  },
});
export const globalFeedbackActions = globalFeedbackSlice.actions;
export default globalFeedbackSlice;